/* eslint-disable no-param-reassign */
/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
/* eslint-disable prefer-destructuring */

import api, {multiPartHeader, partHeader, apiInternal } from '../../api.js';

const moment = require('moment');

moment().format();

const state = {
  all: [],
};

const getters = {
  participantById: state => id => state.all.find(participant => participant.par_id === id),
  participantsByEstaId: state => id => state.all.filter(par => par.establishments && par.establishments.includes(id)),
};

const actions = {
  async getParticipantById({ state, commit }, parId) {
    const result = await api.post(`${apiInternal}/getParticipant`, { par_id: parId },partHeader);
    if (result) {
      commit("updateParticipant", result.data);
    }
    return result;    
  },
  async getParticipantsByEstaId({ state, commit }, estaId) {
    const result = await api.post(`${apiInternal}/getListParticipants`, { esta_id: estaId },partHeader);
    if (result) {
      commit("setParticipants", result.data);
    }
    return result;    
  },
  async importParticipantsList({  commit }, [estaId, formList]) {
    formList.append('esta_id', estaId);
    const result = await api.post(`${apiInternal}/ImportParticipantList`, formlist,multiPartHeader);
    if (result) {
      commit("addParticipantList", result.data);
    }
    return result;    
  },
};

const mutations = {
  setParticipants(state, participants) {
    participants.forEach((newParticipant) => {
      if (newParticipant.par_birthday != null) {
        newParticipant.par_birthday = moment(newParticipant.par_birthday).format('DD/MM/YYYY');
      }
      const index = state.all.findIndex(participant => participant.par_id === newParticipant.par_id);
      if (index >= 0) {
        state.all.splice(index, 1, newParticipant);
      } else {
        state.all.push(newParticipant);
      }
    });
  },
  addParticipantList(state, participantsList) {
    participantsList.forEach((newParticipant) => {
      if (newParticipant.par_birthday != null) {
        newParticipant.par_birthday = moment(newParticipant.par_birthday).format('DD/MM/YYYY');
      }
      const index = state.all.findIndex(participant => participant.par_id === newParticipant.par_id);
      if (index >= 0) {
        state.all.splice(index, 1, newParticipant);
      } else {
        state.all.push(newParticipant);
      }
    });
  },
  updateParticipant(state, newParticipant) {
    if (newParticipant.par_birthday != null) {
      newParticipant.par_birthday = moment(newParticipant.par_birthday).format('DD/MM/YYYY');
    }
    const index = state.all.findIndex(participant => participant.par_id === newParticipant.par_id);
    if (index >= 0) {
      state.all.splice(index, 1, newParticipant);
    } else {
      state.all.push(newParticipant);
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
